import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFileHistoryRequest } from './actions/DataCenterActions';
import moment from 'moment';

const actions = [
    { label: "View this version", action: "view" },
    { label: "Restore this version", action: "restore" },
    // { label: "Duplicate", action: "duplicate" },
    // { label: "Delete", action: "delete" }
]

const ViewFileHistory = ({ dataCenterId, handleActionClick }) => {
    const { fileHistory } = useSelector((state) => state.dataCenter?.fileHistory);
    const dispatch = useDispatch()

    const handleFetchFileHistory = () => {
        dispatch((fetchFileHistoryRequest(dataCenterId)));
    };

    useEffect(() => {
        if (dataCenterId)
            handleFetchFileHistory()
    }, [dataCenterId])

    return (
        <div
            className="offcanvas offcanvas-end filterSecPopup"
            id="viewHistPopup"
            aria-labelledby="viewHistLayout"
        >
            <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="viewHistLayout">
                    View History
                </h5>
                <button
                    type="button"
                    className="btn-close d-none"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                />
            </div>
            <div className="offcanvas-body pt-0 viewHistSec">
                <div className="accordion accordion-flush" id="viewHistory">
                    {fileHistory.map((historyItem, index) => (
                        <div className="accordion-item mt-0" key={index}>
                            <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#viewSec${index}`}
                                    aria-expanded="false"
                                    aria-controls={`viewSec${index}`}
                                >
                                    {moment(historyItem?.date).format("MMM DD, YYYY")}
                                    <span className="mdi mdi-chevron-right" />
                                </button>
                            </h2>
                            <div
                                id={`viewSec${index}`}
                                className="accordion-collapse collapse"
                                data-bs-parent="#viewHistory"
                            >
                                <div className="accordion-body">
                                    {historyItem?.records?.map((version, versionIndex) => {
                                        return (<div className="innerCon_viewHis" key={versionIndex}>
                                            <div>
                                                <span className="viewDate">{moment(version?.updatedTs).format("MMM DD, YYYY hh:mm A")}</span>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span
                                                        className="userimg"
                                                        style={{
                                                            backgroundColor: "rgb(163, 85, 129)",
                                                            color: "white"
                                                        }}
                                                    >
                                                        {version?.userInfo[0]?.firstName?.charAt(0)}{version?.userInfo[0]?.lastName?.charAt(0)}
                                                    </span>
                                                    <div className="flex-grow-1">
                                                        <h6 className="">{version?.userInfo[0]?.firstName} {version?.userInfo[0]?.lastName}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Dropdown menu */}
                                            <div className="dropdown">
                                                <a
                                                    className="btn dropdown-toggle"
                                                    href="#"
                                                    role="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <svg
                                                        width={18}
                                                        height={19}
                                                        viewBox="0 0 18 19"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <rect
                                                            y="18.5"
                                                            width={18}
                                                            height={18}
                                                            rx={9}
                                                            transform="rotate(-90 0 18.5)"
                                                            fill="white"
                                                        />
                                                        <circle
                                                            cx={9}
                                                            cy={14}
                                                            r="1.5"
                                                            transform="rotate(-90 9 14)"
                                                            fill="#94A3B8"
                                                        />
                                                        <circle
                                                            cx={9}
                                                            cy="9.5"
                                                            r="1.5"
                                                            transform="rotate(-90 9 9.5)"
                                                            fill="#94A3B8"
                                                        />
                                                        <circle
                                                            cx={9}
                                                            cy={5}
                                                            r="1.5"
                                                            transform="rotate(-90 9 5)"
                                                            fill="#94A3B8"
                                                        />
                                                    </svg>
                                                </a>
                                                {/* <ul className="dropdown-menu">
                                                    {version.actions.map((action, actionIndex) => (
                                                        <li key={actionIndex}>
                                                            <a
                                                                className="dropdown-item"
                                                                href={action.link}
                                                                type="button"
                                                                data-bs-toggle={actionIndex === 0 ? "offcanvas" : ""}
                                                                data-bs-target={actionIndex === 0 ? "#versionHistory" : ""}
                                                                aria-controls={actionIndex === 0 ? "versionHistory" : ""}
                                                            >
                                                                {action.label}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul> */}
                                                <ul className="dropdown-menu">
                                                    {actions.map((action, actionIndex) => (
                                                        <li key={actionIndex}>
                                                            <button
                                                                className="dropdown-item"
                                                                type="button"
                                                                onClick={() => handleActionClick(version, action.action)}
                                                            >
                                                                {action.label}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            {/* End Dropdown */}
                                        </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ViewFileHistory;